import React, {Component} from 'react'
import PropTypes from 'prop-types'

class DataFetchPage extends Component {
  state = {
    isLoading: false,
    data: null,
  };

  shouldComponentUpdate(nextProps, nextState) {
    return this.state.data !== nextState.data
      || this.props.extraData !== nextProps.extraData;
  }

  componentDidMount() {
    this.refresh();
  }

  async refresh() {
    const data = await this.props.fetch();
    this.setState({data});
  }

  render() {
    const {className, renderToolbar, renderContent} = this.props;
    const data = this.state.data;
    const isLoading = !data;

    const toolbar = renderToolbar && renderToolbar({isLoading, data});
    const content = renderContent && renderContent({isLoading, data});

    return (
      <div className={className}>
        {toolbar}
        {content}
      </div>
    )
  }
}

DataFetchPage.propTypes = {
  className: PropTypes.string,
  fetch: PropTypes.func.isRequired,
  renderToolbar: PropTypes.func.isRequired,
  renderContent: PropTypes.func.isRequired,
};

const styles = {};

export default DataFetchPage;



// WEBPACK FOOTER //
// ./src/components/DataFetchPage.js